"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AddDebtWizard_1 = require("../../../components/Pages/AddDebtWizard/addDebt/AddDebtWizard");
var DebtWizard = function (props) {
    return React.createElement(AddDebtWizard_1.default, { setTCModal: props.setTCModal });
};
exports.default = DebtWizard;
